<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">스토어 명</td>
                <td colspan="3">
                    <div>
                        <el-input v-model="title" @input="parentChange('title', title)"></el-input>
                        <div class="input_error">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">메인 이미지</td>
                <td colspan="3">
                    <div class="d_block" @click="changeType('mainImage')">
                        <el-upload
                            ref="UserImg"
                            class="avatar-uploader"
                            action=""
                            list-type="picture-card"
                            :auto-upload="false"
                            :show-file-list="false"
                            :file-list="mainImage"
                            :on-change="onlyOnePhotoChange"
                        >
                            <i class="el-icon-plus avatar-uploader-icon" v-if="mainImage.length === 0"></i>
                            <div v-else>
                                <img :src="mainImage[0].url" alt="" class="avatar">
                            </div>
                        </el-upload>
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">링크</td>
                <td colspan="3">
                    <div>
                        <el-input v-model="link" @input="parentChange('link', link)"></el-input>
                        <div class="input_error">{{ validation.firstError('link') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">최소 전환가능 포인트</td>
                <td colspan="3">
                    <div>
                        <el-input v-model="minPoint" @input="parentChange('minPoint', minPoint)"></el-input>
                        <div class="input_error">{{ validation.firstError('minPoint') }}</div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import StoreValidator from "@/mixins/validators/StoreValidator";
import elFileMixins from "@/mixins/elFileMixins";
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";

export default {
    name: "StoreWriteDefaultLayout",
    mixins: [StoreValidator, elFileMixins],
    components: {},
    inject: ['storeWriteSetData'],
    provide() {
        return {}
    },
    props: {
        storeData: {},
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        EventBus.$on('StoreWriteDefaultLayoutValidator', this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off('StoreWriteDefaultLayoutValidator');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },

        parentChange(key, value) {
            this.storeWriteSetData(key, value);
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
